import { useEffect, useState } from "react";

const testimonials = [
  {
    text: `Axtelica helped us convert operational data into meaningful business insights. Their AI/ML-based forecasting improved our planning, reporting, and decision-making. The team was highly professional, responsive, and focused on delivering real business value.`,
    name: "Shailendra Tripathi",
    role: "Director (Co-Founder) & CTO, iCtrlBiz Consulting Pvt Ltd",
  },
  {
    text: `Axtelica has been a valuable partner in helping us identify the right talent for our AI and Data Analytics requirements. Their understanding of technology roles, responsiveness, and ability to align skilled professionals with customer needs made the engagement smooth and effective. We appreciate their professionalism and practical approach.`,
    name: "Tanushree M",
    role: "Head of HR, Amniinfotech",
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="mx-auto max-w-6xl px-3 py-6 sm:px-4 sm:py-10">
      <div className="relative overflow-hidden rounded-2xl sm:rounded-[30px] bg-[length:400%_400%] bg-gradient-to-r from-[#0b0116] via-[#3b0a6b] via-[#ff3c6a] to-[#560ba1] p-5 sm:p-8 md:p-10 text-center text-white animate-gradient">

        {/* Stars */}
        <div className="mb-3 sm:mb-4 text-lg sm:text-xl md:text-2xl text-yellow-400">
          ★★★★★
        </div>

        {/* Quote Icon */}
        <div className="mb-2 sm:mb-4 text-4xl sm:text-5xl md:text-6xl leading-none opacity-20">
          "
        </div>

        {/* Testimonial Content */}
        <div className="relative min-h-[280px] xs:min-h-[260px] sm:min-h-[240px] md:min-h-[220px] flex items-center justify-center px-1 sm:px-2">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className={`absolute w-full transition-all duration-1000 ease-out ${
                current === index
                  ? "opacity-100 translate-y-0 visible"
                  : "opacity-0 translate-y-5 invisible"
              }`}
            >
              <p className="mx-auto mb-5 sm:mb-6 md:mb-8 max-w-4xl text-sm sm:text-base md:text-lg lg:text-xl font-light leading-relaxed px-1 sm:px-2">
                "{item.text}"
              </p>

              <div>
                <span className="block text-base sm:text-lg md:text-xl font-semibold text-pink-400 px-2">
                  {item.name}
                </span>

                <span className="mt-1 sm:mt-2 block text-xs sm:text-sm uppercase tracking-[1px] sm:tracking-[2px] text-white/70 px-2">
                  {item.role}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="mt-5 sm:mt-6 md:mt-8 flex justify-center gap-2 sm:gap-3">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              aria-label={`Go to testimonial ${index + 1}`}
              className={`h-1.5 sm:h-2 transition-all duration-300 ${
                current === index
                  ? "w-5 sm:w-7 rounded-full bg-white"
                  : "w-1.5 sm:w-2 rounded-full bg-white/30"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}